
export const trip = {
    TRIP_STATUS_NAME: {
        WAITING_FOR_TRUCK: 1,
        ASSIGNED: 2,
        CONFIRMED: 3,
        REPORTED_AT_SOURCE: 4,
        INTRANSIT: 5,
        REPORTED_AT_DESTINATION: 6,
        CANCELLED: 7,
        DELIVERED: 9,
        INVOICED: 12,
        RECEIVED: 13,
        PAID: 14,
        CLOSED: 15,
        ALLOCATED: 17,
        ADVANCE_PENDING:[4, 5, 6, 9, 12, 14],
        ADDITIONAL_ADVANCE:[5, 6, 9]
    },
    CONFIRMED_TYPE_ID:{
      MANUAL:2
    },
    HALTING_DAYS: [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
        { name: 6 },
        { name: 7 },
        { name: 8 },
        { name: 9 },
        { name: 10 }
      ],
      FILE_TYPE: {
        pod: 'POD',
        aadhar: 'AADHAR',
        lr: 'LR',
        cancel:"Cancellation",
        evidence: 'EVIDENCELIST',
        wh: 'WH',
        customer_pan: 'PAN',
        partner_pan: 'PC',
        emi: 'EMI',
        rc: 'RC',
        insurance: 'insurance',
        permit: 'permit',
        check_leaf: 'CL',
        tds: 'TDS',
        agreement: 'AGREEMENT',
        cibil: 'CIBIL',
        bills: 'BILLS',
        employee_documents: 'CERTIFICATES',
        cheque_collection: 'CHEQUE_COLLECTION',
        debit_file: "PARTNER DEBIT",
        kyc_proof: "KYCPROOF",
        employee: 'employee',
        gst: 'GST',
        relation_ship: 'RS',
        branding: 'Branding',
        additional_document: 'OTHER'
      },
      FOLDER: {
        pod_lr: 'pod/',
        customer_lr: 'lr/',
        customer_gst: 'customer_gst/',
        customer_additional_files: 'customer_additional_files/',
        approvals: 'approvals/',
        any_account: 'any_account/',
        wh: 'warehousereceipt/',
        customer_pan: 'pan/',
        ticket: 'ticket/',
        expense: 'employee_expense/expense/',
        advance: 'employee_expense/advance/',
        employee_aadhar: 'employee/employeeAadhar/',
        employee_photo: 'employee/employee_photo/',
        employee_pan: 'employee/pan/',
        employee_bank_passbook: 'employee/bank_passbook/',
        employee_mother_aadhar: 'employee/motherAadhar/',
        employee_spouse_aadhar: 'employee/spouseAadhar/',
        employee_father_aadhar: 'employee/fatherAadhar/',
        employee_experience_certificate: 'employee/experience_certificate/',
        employee_form_12b: 'employee/form_12b/',
        fr8_appointment_letter: 'employee/fr8_appointment_letter/',
        employee_hsc_certificate: 'employee/hsc_certificate/',
        employee_other_certificates: 'employee/other_certificate/',
        employee_pay_slip: 'employee/pay_slip/',
        employee_pg_certificate: 'employee/pg_certificate/',
        previous_employer_appointment_letter: 'employee/previous_employer_appointment_letter/',
        previous_employer_relieving_letter: 'employee/previous_employer_relieving_letter/',
        employee_resume: 'employee/resume/',
        employee_sslc_certificate: 'employee/sslc_certificate/',
        employee_ug_certificate: 'employee/ug_certificate/',
        cheque_collection: 'customer/customer_cheque/',
        additional_files: 'additional_files'
      },
       TRIP_CANCELLATION_CHARGE_MAX_AMOUNT: 10000,
       other_charges_id: 3,
       loading_charges_id: 5,
       unloading_charges_id: 6,
       loading_halting_charges_id: 7,
       CREDIT_DEBIT_SUPPORT_LIST: [
        { id: 5, label: 'Loading Charges', fileType: 'LOADING_CHARGES' },
        { id: 6, label: 'Unloading Charges', fileType: 'UNLOADING_CHARGES' },
        { id: 7, label: 'Loading Halting', fileType: 'LOADING_HALTING' },
        { id: 8, label: 'Unloading Halting', fileType: 'UNLOADING_HALTING' },
        { id: 9, label: 'Hiring Charge', fileType: 'COMMISSION_FEE' },
        { id: 10, label: 'Late Delivery Fee', fileType: 'LATE_DELIVERY_FEE' },
        { id: 11, label: 'POD Late Fee', fileType: 'POD_LATE_FEE' },
        { id: 12, label: 'POD Missing', fileType: 'POD_MISSING' },
        { id: 14, label: 'Price Difference', fileType: 'PRICE_DIFFERENCE' },
        { id: 15, label: 'On-Hold', fileType: 'ON_HOLD' },
        { id: 16, label: 'Trip Cancellation', fileType: 'TRIP_CANCELLATION' },
        { id: 17, label: 'TDS', fileType: 'TDS' }
      ],
      CREDIT_DEBIT :  [
        { id: 5, label: 'Loading Charges' },
        { id: 6, label: 'Unloading Charges' },
        { id: 7, label: 'Loading Halting' },
        { id: 8, label: 'Unloading Halting' },
        { id: 17, label: 'TDS' },
        { id: 18, label: 'Discount Charge' }
    ],
    CREDIT_DEBIT_TYPE:{
      LOADING_CHARGES:5,
      UNLOADING_CHARGES:6,
      LOADING_HALTING:7,
      UNLOADING_HALTING:8,
      COMMISSION_FEE:9,
      LATE_DELIVERY_FEE:10,
      POD_DATE_FEE:11,
      POD_MISSION:12,
      PRICE_DIFFERNECE:14,
      ON_HOLD:15,
      TRIP_CANCELLATION:16,
      TDS:17,
      DISCOUNT_CHARGE:18
    },
    PAYMENT_MODE: {
      BANK:'BANK',
      PARTNER_BANK:'PARTNER BANK',
      WALLET:'WALLET'
    },
    GOOGLE_MAP_URL: `https://www.google.com/maps/place/`,
    APPROVAL_STATUS: {
      APPROVED: 1,
      PENDING: 2,
      REJECTED: 3
    },
    BILLING_COMMENT: "Billing Comment",
    TDS_CREDIT_TYPE_ID: 17,
    PARTNER_ADVANCE:{
      DEFAULT_PARTNER_ADV_PERCENTAGE: 70,
      DEFAULT_PARTNER_NEW_ADV_PERCENTAGE: 60,
      EFFECTIVE_FROM: "2025-10-01 00:00:00"
  },
EWAY_BILL:{
  ULIP_LIMIT:4
},
AllOWED_BRANCH:[53, 9, 31, 10, 25, 58, 5, 12],
LOADED:{
YES:"Yes",
NO:"No"
},
LR_STATUS_ID:{
  PENDING:1,
  APPROVED:2
},
LEAD_SCREEN_NAME:{
  INDENT_DETAIL_INTEREST:12,
  INDENT_DETAIL_MATCHED:13,
  INDENT_DETAIL_HISTORY:14,
  INDENT_DETAIL_TRUCKS:15
},
UPI_PAYMENT_TYPE: {
  CUSTOMER_ADVANCE: 'Customer Advance',
  CUSTOMER_BALANCE: 'Customer Balance',
  COMMISSION_AMOUNT: 'Commission Amount'
},
TRIP_PAYMENT_PROCESS: {
  ADVANCE: 1,
  BALANCE: 3
},
// Official NIC reason codes for E-way bill extend validity (note the gap —
// no code 3 in NIC's own scheme).
EWB_EXTEND_REASONS: [
  { code: 1, label: "Natural Calamity" },
  { code: 2, label: "Law and Order Situation" },
  { code: 4, label: "Transshipment" },
  { code: 5, label: "Accident" },
  { code: 99, label: "Others" },
],
EWB_EXTEND_OTHERS_REASON_CODE: 99,
// Official NIC reason codes for Part-B update — matches
// help/src/apps/employee/trip/partB/core.ts's reason_code: 1|2|3|4 exactly.
// Display order is "Others" last, independent of the code values themselves
// (which stay tied to their official NIC meaning).
EWB_PARTB_REASONS: [
  { code: 1, label: "Due to Break Down" },
  { code: 2, label: "Due to Transshipment" },
  { code: 4, label: "First Time" },
  { code: 3, label: "Others" },
],
EWB_PARTB_OTHERS_REASON_CODE: 3
}
